import { connect } from 'react-redux';
import { getChatHasMessage } from '../../../Notes/redux/unreadChats/selectors';
const mapStateToProps = (state)=>({
        hasNewMsg: getChatHasMessage(state)
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
